import api from 'services/api'
import { IFile } from 'types/File.types'

export class FileService {
  postFile = (form: FormData) => api.post<IFile>('files', form)
}
